import m from "mithril";
import { dialog } from "../dialog/dialog";
import { getTextFixed } from "../../state/translations";
import "./orderDialog.scss";
// import { getAsset } from "../../utils/utils"
export const orderDialog = () => {
    let pct = 0;
    const d = dialog({
        // title: getTextFixed("PLACING_ORDER"),
        close: false,
        dismiss: false,
        backdrop: true,
        className: "order-dialog"
    }, _close => [
        // <img src={getAsset("images/loading.gif")} />,
        m("p", null, getTextFixed("PLEASE_WAIT_WHILE_WE_PLACE_YOUR_ORDER")),
        m("div", { class: "order-progress-bar" },
            m("div", { class: "order-progress-bar__track" },
                m("div", { class: "order-progress-bar__fill", style: { width: pct + "%" } })),
            m("span", { class: "order-progress-bar__label" },
                pct,
                "%"))
    ]);
    return {
        promise: d.promise,
        close: d.close,
        update: (c, t) => {
            pct = Math.round((c / t) * 100);
            m.redraw();
        }
    };
};
